import React from "react";

export const PageLoader = () => {
  return (
    <div></div>
  );
};
